import { render } from "./MainButtonIcon.vue?vue&type=template&id=037baf34&scoped=true"
import script from "./MainButtonIcon.vue?vue&type=script&lang=js"
export * from "./MainButtonIcon.vue?vue&type=script&lang=js"

import "./MainButtonIcon.vue?vue&type=style&index=0&id=037baf34&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-037baf34"]])

export default __exports__